

















































































































































import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faPlus, faPlusCircle } from '@fortawesome/free-solid-svg-icons';

// Utils
import Toast from '@common/helpers/toast';
import LocalStorageUtils from '@common/LocalStorageUtils';
import ApiHelper from 'api-helper';
// Components
import Pagination from '@components/common/Pagination.vue';
import PageLoader from '@components/common/PageLoader.vue';
import ContentLayout from '@components/layouts/Content.vue';
import BasicSelect from '@/components/common/BasicSelect.vue';
// Constants
import { MENU_DEFAULT, MENU_STATUS } from '@/common/app.config';
// Icons
import Listicon from '@/assets/img/icon-diagnosis.svg';
import { SelectType } from '@/common/interfaces/common';
import PopupConfirmDelete from './components/PopupConfirmDelete.vue';
import PopupConfirmCopy from '@/components/common/PopupConfirmCopy.vue';
import PopupCopyResult from '@/components/common/PopupCopyResult.vue';

@Component({
  components: {
    Pagination,
    PageLoader,
    ContentLayout,
    BasicSelect,
    PopupConfirmDelete,
    PopupConfirmCopy,
    PopupCopyResult,
  },
  data() {
    return {
      listDiagnosis: [],
      iconHeader: Listicon,
    };
  },
})
export default class List extends Vue {
  get isSuperAdminRole() {
    return this.currentUser.isSuperAdminRole;
  }

  get menuStatus(): SelectType[] {
    return MENU_STATUS;
  }

  get menuDeafult(): SelectType[] {
    return MENU_DEFAULT;
  }

  get selectedCopyItemsData() {
    return this.listDiagnosis.filter((item) => this.selectedCopyItems.includes(item.id));
  }

  public iconHeader: any;
  public page = this.$route.query.page || 1;
  public perPage = 20;
  public pageCount = 1;
  public listDiagnosis!: any;
  public isLoading: boolean = false;
  public isOpenMenu: boolean = false;
  public selectedMenu: any = {};
  public isCopyMenu: boolean = false;
  public selectedCopyItems: number[] = [];
  public selectedCopyItemsDataFull: any[] = [];
  public copyTimeout: any = null;
  @State((state) => state.auth.currentUser) currentUser!: any;

  public searchForm = {
    name: this.$route.query.name || '',
    clinic_name: this.$route.query.clinic_name,
    order: '-created_at',
    per_page: this.perPage,
    page: this.page,
    with: 'clinics',
    menu_status: this.$route.query.menu_status === '0' ? 0 : parseInt(this.$route.query.menu_status as string) || null,
    is_default: this.$route.query.is_default === '0' ? 0 : parseInt(this.$route.query.is_default as string) || null,
    select_field: 'id,name,status,is_default',
  };
  private selectMenuStatusId!: number;

  public searchDiagnosis() {
    this.searchForm.page = 1;
    LocalStorageUtils.saveItem('params_search_diagnosis', JSON.stringify(this.searchForm));

    this.page = 1;
    this.getDiagnosisList(this.searchForm);
  }

  public pageChanged(page) {
    let paramsSearch: any;

    if (LocalStorageUtils.getItem('params_search_diagnosis')) {
      paramsSearch = JSON.parse(LocalStorageUtils.getItem('params_search_diagnosis'));
    } else {
      paramsSearch = Object.assign({}, this.searchForm);
      paramsSearch.name = '';
    }

    paramsSearch.page = page;
    LocalStorageUtils.saveItem('params_search_diagnosis', JSON.stringify(paramsSearch));
    this.page = page;
    this.getDiagnosisList(paramsSearch);
  }

  public async showPopup(event, name, item) {
    event.preventDefault();
    event.stopPropagation();
    this.$modal.show(name);
    this.selectedMenu = item;
    this.isOpenMenu = false;
  }

  debouncedSearch(status) {
    if (this.selectMenuStatusId) {
      clearTimeout(this.selectMenuStatusId);
    }
    this.$nextTick(() => {
      this.selectMenuStatusId = setTimeout(this.onSearch, 2000);
    });
  }

  onSearch($state) {
    this.getDiagnosisList(this.searchForm);
  }

  deleteMenu(data) {
    this.getDiagnosisList(this.searchForm);
  }

  copyMenu() {
    this.isCopyMenu = true;
  }

  cancelCopyMenu() {
    this.isCopyMenu = false;
    this.selectedCopyItems = [];
    this.selectedCopyItemsDataFull = [];
  }

  handleCheckboxChange(item) {
    const exists = this.selectedCopyItems.includes(item.id);
    if (exists) {
      const found = this.selectedCopyItemsDataFull.find((i) => i.id === item.id);
      if (!found) {
        this.selectedCopyItemsDataFull.push(item);
      }
    } else {
      this.selectedCopyItemsDataFull = this.selectedCopyItemsDataFull.filter((i) => i.id !== item.id);
    }
  }

  showModalConfirmCopy() {
    this.$modal.show('popup-confirm-copy', {
      selectedItems: this.selectedCopyItemsDataFull,
      title: '診療サービス複製',
      description: '本当に複製しますか？',
    });
  }

  beforeDestroy() {
    this.$off('MenuCopyResult');
  }

  public async handleCopyConfirmed(ids: number[]) {
    if (!ids.length) {
      return;
    }

    try {
      this.isLoading = true;
      const menu_ids = ids;
      await ApiHelper.getApi('MedicalMenuApi').copyMenus({ menu_ids });
      Toast.info('コピーを実行中です。完了までしばらくお待ちください。');
    } catch (error) {
      Toast.error('コピーが失敗しました。');
      return;
    } finally {
      if (this.copyTimeout) {
        clearTimeout(this.copyTimeout);
      }
      this.copyTimeout = setTimeout(() => {
        this.isLoading = false;
        this.isCopyMenu = false;
        this.selectedCopyItems = [];
        this.selectedCopyItemsDataFull = [];
      }, 3000);
    }
  }

  public retryFailedItems(failedItems: any[]) {
    const retryIds = failedItems.map((item) => item.id);
    this.page = 1;
    this.searchForm.page = 1;
    this.handleCopyConfirmed(retryIds);
  }

  private async created() {
    if (LocalStorageUtils.getItem('params_search_diagnosis') && this.$route.query.state !== 'new') {
      this.searchForm = {
        ...JSON.parse(LocalStorageUtils.getItem('params_search_diagnosis')),
      };

      this.page = this.searchForm.page;
    }
    LocalStorageUtils.removeItem('paramsSearch');

    LocalStorageUtils.removeItem('params_search_diagnosis');

    this.getDiagnosisList(this.searchForm);
  }

  private mounted() {
    library.add(faPlus);
    library.add(faPlusCircle);
    dom.watch();
    this.listenSocketMenuCopyResult();
  }

  private listenSocketMenuCopyResult() {
    this.$on('MenuCopyResult', ({ message, success, failed }) => {
      if (this.copyTimeout) {
        clearTimeout(this.copyTimeout);
        this.copyTimeout = null;
      }

      this.isLoading = false;

      this.selectedCopyItems = this.selectedCopyItems.filter(
        (id) => !success.some((item) => item.id === id),
      );

      if (this.selectedCopyItems.length === 0) {
        this.isCopyMenu = false;
      }

      this.$modal.hide('popup-confirm-copy');

      if (failed.length === 0 ) {
        Toast.success(message || 'コピーが完全に完了しました。');
        this.$modal.hide('popup-confirm-copy');
        this.page = 1;
        this.searchForm.page = 1;
        this.getDiagnosisList(this.searchForm);
        this.isCopyMenu = false;
        this.selectedCopyItems = [];
        this.selectedCopyItemsDataFull = [];
      } else {
        this.$modal.show('popup-copy-result', {
          success,
          failed,
          message,
          type: 'menu',
        });
      }
    });
  }

  private async getDiagnosisList(data) {
    try {
      this.isLoading = true;
      const res = await ApiHelper.getApi('MedicalMenuApi').getList(data);
      this.listDiagnosis = res.data;
      this.pageCount = res.last_page;
      this.isLoading = false;
    } catch (error) {
      this.toast(error);
      this.isLoading = false;
    }
  }

  private toast(error: any) {
    const {
      errors: { id: idError },
    } = error.response.data;
    if (idError) {
      return Toast.error('英数字で入力してください。');
    }
    Toast.error(error.response.data.message);
  }

  private makeClinicNames(clinicsName) {
    return clinicsName?.map((clinic) => clinic.name).join(', ');
  }

  private makeStatusMenu(status) {
    return MENU_STATUS.find((item) => item.value === status)?.name ?? '-';
  }
}
